
import { toRefs, reactive, onBeforeMount, computed } from "vue";
import { fetchServiceConfiguration } from "@/helpers/api";
import VueFeather from "vue-feather";
import { getEditNavBar, getSelectedPages, hasRole, isExternalUser, updatePages } from "@/helpers/store";
import draggable from "vuedraggable";
import BurstCollector from "@/components/BurstCollector.vue";
import { useRoute } from "vue-router";

export default {
  name: "TheNavBar",
  components: {
    VueFeather,
    draggable,
    BurstCollector,
  },
  setup() {
    const state = reactive({
      siteName: "",
      editNavBar: getEditNavBar(),
      selectedPages: getSelectedPages(),
    });

    const route = useRoute();

    const path = computed(() => route.name);

    // watchEffect(() => console.dir(path.value));

    const update_pages = () => {
      if (state.selectedPages !== null) {
        updatePages(state.selectedPages);
      }
    };

    onBeforeMount(async () => {
      const siteName = await fetchServiceConfiguration();
      state.siteName = siteName.siteName;
    });

    const hasCommissioningAccess = () => hasRole("commissioning_admin") || hasRole("eol_admin");

    const COMMISSIONING_LINKS = new Set(["/damagedb", "/commissioning"]);

    const isPageVisible = (element: { enabled: boolean; link: string }) =>
      element.enabled && (!COMMISSIONING_LINKS.has(element.link) || hasCommissioningAccess());

    return {
      ...toRefs(state),
      update_pages,
      path,
      isExternalUser,
      isPageVisible,
    };
  },
};
